export enum CampaignStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  COMPLETED = 'completed',
}

export enum CampaignChannel {
  EMAIL = 'email',
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
  VOICE = 'voice',
}

export enum AudienceType {
  MANUAL = 'manual',
  SEGMENT = 'segment',
}

export enum CampaignLeadStatus {
  PENDING = 'pending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  SKIPPED = 'skipped',
}

export interface SegmentFilters {
  stageIds?: string[];
  tags?: string[];
  sources?: string[];
  dateRange?: {
    from?: string;
    to?: string;
  };
  assignedToIds?: string[];
}

export interface Campaign {
  id: string;
  organizationId: string;
  name: string;
  description: string | null;
  channels: CampaignChannel[];
  status: CampaignStatus;
  audienceType: AudienceType;
  segmentFilters: SegmentFilters | null;
  totalLeads: number;
  sentCount: number;
  deliveredCount: number;
  failedCount: number;
  scheduledAt: string | null;
  activatedAt: string | null;
  completedAt: string | null;
  createdById: string;
  createdBy?: { id: string; fullName: string };
  _count?: { campaignLeads: number };
  createdAt: string;
  updatedAt: string;
}

export interface CampaignLead {
  id: string;
  campaignId: string;
  leadId: string;
  status: CampaignLeadStatus;
  channel: CampaignChannel | null;
  sentAt: string | null;
  deliveredAt: string | null;
  failedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
  lead?: {
    id: string;
    fullName: string | null;
    email: string | null;
    phone: string | null;
    company: string | null;
  };
}

export interface PaginatedCampaigns {
  campaigns: Campaign[];
  total: number;
  limit: number;
  offset: number;
}

export interface PaginatedCampaignLeads {
  campaignLeads: CampaignLead[];
  total: number;
  limit: number;
  offset: number;
}

export interface CreateCampaignInput {
  organizationId: string;
  name: string;
  description?: string;
  channels: CampaignChannel[];
  audienceType?: AudienceType;
  segmentFilters?: SegmentFilters;
  scheduledAt?: string;
}

export interface UpdateCampaignInput {
  name?: string;
  description?: string;
  channels?: CampaignChannel[];
  segmentFilters?: SegmentFilters;
  scheduledAt?: string;
}

export interface QueryCampaignsParams {
  organizationId: string;
  status?: CampaignStatus;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface CampaignActiveCount {
  count: number;
}

export interface AudiencePreview {
  count: number;
  filters: SegmentFilters;
}
